// extracted by mini-css-extract-plugin
export default {"container":"ImageUpload_container__5SJII","file":"ImageUpload_file__oRLkQ","icon":"ImageUpload_icon__Y749t","spin":"ImageUpload_spin__YkXeo"};